export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  AGENT_MANAGEMENT: 'agent_management',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  INSERT_ARTICLE_IN_REPLY: 'insert_article_in_reply',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  RESPONSE_BOT: 'response_bot',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TWITTER: 'channel_twitter',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  AOIKUMO: 'aoikumo_integration',
  CAPTAIN: 'captain_integration',
  KNOWLEDGE: 'knowledge',
  GOOGLE_SHEET: 'google_sheet',
  BILLING: 'billing',
  SUBSCRIPTION_SETTINGS: 'subscription_settings',
  APPOINTMENTS: 'appointments',
  BRANCHES: 'branches',
  KNOWLEDGE_IMPROVEMENT: 'knowledge_improvement',
  PROMO_CODE: 'PROMO_CODE',
  RENTAL_BRANCHES: 'rental_branches',
  RENTAL_BOOKINGS: 'rental_bookings',
  WHITELIST: 'whitelist',
  CONDO_MANAGEMENT: 'condo_management',
  E_VOUCHER: 'eVoucher',
  ORGANIZATION: 'organization',
};
